<template>
  <v-row justify="center" class="ma-0">
    <v-col cols="12" class="pa-0">
      <v-toolbar color="primary" height="60" dark class="elevation-0">
        <v-toolbar-title>個性</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-col>
    <v-col cols="12" class="pa-0">
      <v-card>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="6" class="py-0">
                <v-select
                  ref="type"
                  :prepend-icon="$PERSONALITY_ICONS[type]"
                  :color="$PERSONALITY_COLORS[type]"
                  :items="types"
                  label="種別"
                  v-model="type"
                  class=""
                  dense
                  item-text="name"
                  item-value="key"
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
              <v-col cols="6" class="py-0">
              </v-col>
               <v-col cols="12" class="py-0">
                <v-text-field
                  ref="comment"
                  label="*内容"
                  v-model="comment"
                  class="my-0 pa-0"
                  :rules="[rules.required]"
                ></v-text-field>
               </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded depressed @click.native="close()">取消</v-btn>
          <v-btn rounded depressed color="primary" @click.native="submit()">登録</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>

  </v-row>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      formHasErrors: false,
      types: [
        { name: '性格', key: 'personality' },
        { name: '勉強', key: 'study' },
        { name: '部活', key: 'sport' },
        { name: '趣味', key: 'hobby' },
        { name: '好物', key: 'food' },
        { name: '将来の夢', key: 'dream' },
        { name: '他', key: 'other' }
      ],
      type: null,
      comment: null,
      rules: {
        required: value => !!value || '必須'
      }
    }
  },
  props: [ 'item', 'dialog' ],
  methods: {
    close () {
      this.$emit('dismissed', null)
    },
    submit () {
      if (!this.comment || !this.type) {
        this.$refs.comment.validate(true)
        this.$refs.type.validate(true)
      } else {
        var payload = {
          type: this.type,
          comment: this.comment,
          done: true
        }
        this.$emit('dismissed', payload)
      }
    }
  }
}
</script>
